export default {
    formatPrivacyPolicyEffectiveDate: (date) => {
        const formatter = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        return formatter.format(date);
    }
};